import type { CategoryType } from './CategoryType';
import type { CompSkin } from './CompSkin';
import type { CompType } from './CompType';
import type { EntityBase } from './Entities';
import type { Group } from './groups';
import type { ModeId } from './modes';
import type { SectionItemDataType } from './SectionItemDataType';
import type { SourceType } from './SourceType';
import type { StyleType } from './StyleType';

export enum CustomCategoryId {
  UserImage = 'userImage',
}

export interface Help {
  helpId: string;
  hide?: boolean;
}

interface HintProps {
  id: string;
}

export interface CategoryBase extends EntityBase {
  // TODO: add automationId as we have for sections
  id: string;
  isCustom?: boolean;
  hasSubcategory?: boolean;
  appDefinitionId?: string;
  translations: {
    label: string;
    /**
     * @deprecated only used in old editor workspace (pre-facelift)
     */
    title: string;
  };
  help?: Help;
  hintProps?: HintProps;
  type?: CategoryType;
  modes: ModeId[];
}

export interface Category extends CategoryBase {
  groups: Group[];
  hasCategorySearch?: boolean;
  showSectionsOnlyForSelectedGroup?: boolean;
}

export interface CategoryOverride extends Category {
  categoryToOverride: string;
}

export type Categories = Category[];

interface IconProps {
  text: string;
  title: string;
  helpId?: string;
  learnMoreText?: string;
}

export type IconEnabledForComps = Partial<{ [CT in CompType]: IconProps | ((data: SectionItemData) => IconProps) }>;

interface StructureStyle {
  type: string;
  id: string;
  metaData: MetaData;
  style: {
    groups: Record<string, unknown>;
    properties: Record<string, unknown>;
    propertiesSource: Record<string, unknown>;
  };
  componentClassName: CompType;
  pageId: string;
  compId: string;
  styleType: StyleType;
  skin: CompSkin;
}

interface Design {}

export interface Structure {
  componentType: CompType;
  data: SectionItemData;
  style: StructureStyle | string;
  styleId: string;
  design: Design;
}

interface MetaData {
  isPreset: boolean;
  schemaVersion: string;
  isHidden: boolean;
}

interface SectionItemData {
  freezeFrame: boolean;
  metaData: MetaData;
  sourceType: SourceType;
  type: SectionItemDataType;
  url: string;
}
